module.exports = __webpack_public_path__ + "static/media/backgroundTennis_Dark.5a3d1f00.svg";